import * as React from "react";
import { makeStyles, shorthands } from "@fluentui/react-components";
import { FirmaCard } from "./FirmaCard";
import { useStateStore } from "../../store";
import { t } from "../../utils/translations";

const useStyles = makeStyles({
  main: {
    ...shorthands.gap("16px"),
    ...shorthands.padding("5px"),
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
  },
});

export const SelectableSignatures = () => {
  const { firmas, signatureId, setSignatureId } = useStateStore((state) => ({
    firmas: state.firmas,
    signatureId: state.signatureId,
    setSignatureId: state.setSignatureId,
  }));
  const styles = useStyles();

  const selectSignature = (signature) => {
    setSignatureId(signature.id_file);
    if (Office.context.mailbox) {
      Office.context.mailbox.item.body.setSignatureAsync(signature.file, {
        coercionType: "html",
      });
    } else {
      console.log("Mock: Signature set to", signature.id_file);
    }
  };

  return (
    <div className={styles.main}>
      {firmas.map((signature) => (
        <FirmaCard
          key={signature.id_file}
          signature={signature}
          onSelect={(e, selectedSignature) => {
            e.stopPropagation();
            selectSignature(selectedSignature);
          }}
          selected={signatureId === signature.id_file}
        />
      ))}
      {firmas.length === 0 && <p>{t("noSignatures")}</p>}
    </div>
  );
};
